export default class AngelOneGreeksWebSocketException extends Error {
  constructor(message, cause) {
    super(message);
    this.name = "AngelOneGreeksWebSocketException";
    this.cause = cause;
  }
}
